"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  hu: {
    reactMuiTables: {
      selected: 'kiválasztva',
      filterhide: 'rejtett szûrõ',
      filtershow: 'mutasd a szûrõt',
      refresh: 'újra frissítés',
      filter: {
        actions: {
          search: 'keresés',
          resetFilter: 'szûrõ visszaállítása',
          addCondition: 'feltétel hozzáadása'
        }
      },
      standardOperators: {
        equals: 'egyezik',
        contains: 'tartalmaz',
        between: {
          label: 'közötte',
          from: '-tól',
          to: '-ig'
        },
        oneOf: 'egy a -ból'
      },
      labelRowsPerPage: 'sorok oldalanként:'
    }
  }
};
var _default = messages;
exports.default = _default;